export const environment = {
	production: false,
	msalConfig: {
		auth: {
			clientId: 'fd873f84-96f5-4e93-82f0-cad5dfeeee44',
			authority: 'https://progresccrr.ciamlogin.com/c8833157-5186-42f0-8016-4badd4bf54e3',
			redirectUri: 'http://localhost:4200/auth/callback',
			postLogoutRedirectUri: 'http://localhost:4200/signin'
		}
	},
	apiConfig: {
		scopes: ['openid','profile','offline_access','api://fd873f84-96f5-4e93-82f0-cad5dfeeee44-prod/access_as_user'],
		uri: 'http://localhost:8080/graph/dummy'
	},
	internalApi: {
		key: '6693694a69dc4a3ea8b2d449a6266cbb'
	},
	baseUrl: {
		auth: 'https://apim-net3-prod.azure-api.net/users',
		data: 'https://apim-net3-prod.azure-api.net/data',    	
	},
	logoutUrl:'',
  postHogKey:'phc_XPU8eJoH07FA7zxcm4w7ZgUCKVVgCYUGi4vtf5Qv9JN'
};
